import {Typography} from 'components/Typography';
import {FC} from 'react';
import style from './style.module.scss';

interface IProps {
    description: string;
    title: string;
}

export const FaqCard: FC<IProps> = ({description, title}) => {
    return (
        <div className={style.main}>
            <Typography variant={'label-16-m'}>{title}</Typography>
            <Typography className={style.description} element={'div'} variant={'body-16-r'}>
                {description}
            </Typography>
        </div>
    );
};
